import { FileUploadState } from "./fileUploadSlice";

const selectAll = (state: { fileUpload: FileUploadState }) => state.fileUpload;

export const uploadFileSelectors = {
  selectAll
};
